import React from 'react';
import {
  DashboardShell,
  StatCards,
  DataTable,
  WalletCta,
  SimpleBarChart,
  formatPoints,
  downlineColumns,
} from './DashboardShared';

const SalesTemplate = ({ data }) => {
  const cards = data.cards || {};

  return (
    <DashboardShell
      title={`${data.company.name} — Sales & Network`}
      subtitle="Your commissions and team performance"
      data={data}
    >
      <StatCards
        items={[
          { label: 'Wallet balance', value: formatPoints(data.wallet_balance) },
          { label: 'Points this month', value: formatPoints(cards.points_this_month) },
          { label: 'Points all-time', value: formatPoints(cards.points_all_time) },
        ]}
      />

      {!data.has_mlm_node && (
        <section className="cd-panel">
          <p className="cd-empty">
            You are not assigned to a commission tree yet. Contact your administrator.
          </p>
        </section>
      )}

      {data.has_mlm_node && (
        <DataTable
          title="People below you"
          columns={downlineColumns}
          rows={data.team || []}
          emptyMessage="No one is assigned under you in the commission tree yet."
        />
      )}

      {data.product_mix_chart?.length > 0 && (
        <section className="cd-panel">
          <h2 className="cd-panel-title">Sales by product</h2>
          <SimpleBarChart data={data.product_mix_chart} />
        </section>
      )}

      <DataTable
        title="Recent commissions (sales that paid you)"
        columns={[
          { key: 'date', label: 'Date', render: (row) => row.date?.split(' ')[0] ?? '—' },
          { key: 'product_name', label: 'Product' },
          { key: 'service_name', label: 'Sale type' },
          { key: 'seller_name', label: 'Sold by', render: (row) => row.seller_name ?? '—' },
          {
            key: 'percentage',
            label: '%',
            render: (row) => (row.percentage != null ? `${row.percentage}%` : '—'),
          },
          {
            key: 'amount',
            label: 'Points',
            render: (row) => `+${formatPoints(row.amount)}`,
          },
        ]}
        rows={data.recent_commissions || []}
      />

      <WalletCta />
    </DashboardShell>
  );
};

export default SalesTemplate;
